module.exports = __webpack_public_path__ + "media/images/avatar/24-5ec102567ca6a617bf7dd5a00dda95ea.svg";